import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { TrustBar } from "@/components/TrustBar";
import { WDVSFocus } from "@/components/WDVSFocus";
import { ServiceClusters } from "@/components/ServiceClusters";
import { EnergieKlima } from "@/components/EnergieKlima";
import { AboutSEO } from "@/components/AboutSEO";
import { LocalRelevance } from "@/components/LocalRelevance";
import { FAQShort } from "@/components/FAQShort";
import { References } from "@/components/References";
import { GoogleReviews } from "@/components/GoogleReviews";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { CookieConsent } from "@/components/CookieConsent";

const Index = () => {
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://malerfachbetrieb-stein.de/#localbusiness",
    "name": "Malerfachbetrieb Stein GmbH & Co. KG",
    "image": "https://malerfachbetrieb-stein.de/logo.png",
    "priceRange": "€€",
    "description": "Meistergeführter Malerfachbetrieb in Herford – Spezialist für Fassadendämmung (WDVS), Innendämmung, Schimmelsanierung, energetische Sanierung, Malerarbeiten und fugenlose Bäder.",
    "telephone": "+4952213832130",
    "email": "info@malerfachbetrieb-stein.de",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Mindener Str. 183",
      "addressLocality": "Herford",
      "postalCode": "32049",
      "addressCountry": "DE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 52.1135,
      "longitude": 8.6784
    },
    "url": "https://malerfachbetrieb-stein.de",
    "hasMap": "https://maps.app.goo.gl/U84PKHcSVFYAnegZ9",
    "sameAs": [
      "https://maps.app.goo.gl/U84PKHcSVFYAnegZ9"
    ],
    "areaServed": [
      { "@type": "City", "name": "Herford" },
      { "@type": "City", "name": "Hiddenhausen" },
      { "@type": "City", "name": "Löhne" },
      { "@type": "City", "name": "Bünde" },
      { "@type": "City", "name": "Enger" },
      { "@type": "City", "name": "Spenge" },
      { "@type": "City", "name": "Bad Oeynhausen" },
      { "@type": "City", "name": "Vlotho" },
      { "@type": "City", "name": "Kirchlengern" },
      { "@type": "City", "name": "Bielefeld" }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Leistungen",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Fassadensanierung & WDVS Herford", "url": "https://malerfachbetrieb-stein.de/fassadensanierung-wdvs-herford" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Innendämmung & Schimmelschutz Herford", "url": "https://malerfachbetrieb-stein.de/innendaemmung-schimmelschutz-herford" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Energetische Sanierung Herford", "url": "https://malerfachbetrieb-stein.de/energetische-sanierung-herford" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Innensanierung & Malerarbeiten Herford", "url": "https://malerfachbetrieb-stein.de/innensanierung-malerarbeiten-herford" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Fugenlose Bäder & Badrenovierung Herford", "url": "https://malerfachbetrieb-stein.de/badrenovierung-fugenlose-baeder-herford" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Edle Oberflächen & Designböden Herford", "url": "https://malerfachbetrieb-stein.de/edle-oberflaechen-designboeden-herford" } }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.7",
      "reviewCount": "25"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "07:00",
        "closes": "17:00"
      }
    ]
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      { "@type": "Question", "name": "Was kostet eine Fassadendämmung (WDVS) in Herford?", "acceptedAnswer": { "@type": "Answer", "text": "Die Kosten hängen von Materialwahl (EPS, Mineralwolle, Resol) und dem Zustand Ihrer Fassade ab. Wir bieten einen kostenlosen Vor-Ort-Check und ein transparentes, individuelles Angebot." } },
      { "@type": "Question", "name": "Welche Innendämmung hilft sicher gegen Schimmel?", "acceptedAnswer": { "@type": "Answer", "text": "Wir setzen primär auf Calciumsilikatplatten – feuchtigkeitsregulierend und rein mineralisch. Das alkalische Material entzieht Schimmel dauerhaft den Nährboden." } },
      { "@type": "Question", "name": "Bieten Sie kostenlose Besichtigungen an?", "acceptedAnswer": { "@type": "Answer", "text": "Ja, im gesamten Kreis Herford beraten wir unverbindlich vor Ort. Innerhalb von 24 Stunden melden wir uns – unser Rückruf-Versprechen." } },
      { "@type": "Question", "name": "Welche Förderungen gibt es für Fassadendämmung in Herford?", "acceptedAnswer": { "@type": "Answer", "text": "Über die KfW (BEG) sind bis zu 20 % Zuschuss möglich, ergänzt durch BAFA-Förderung für Einzelmaßnahmen. Wir beraten Sie im Fassaden-Check zu allen Fördermöglichkeiten." } },
      { "@type": "Question", "name": "In welchen Städten sind Sie tätig?", "acceptedAnswer": { "@type": "Answer", "text": "Herford und gesamter Kreis Herford: Hiddenhausen, Löhne, Bünde, Enger, Spenge, Bad Oeynhausen, Vlotho, Kirchlengern. Auch Bielefeld, Detmold, Lemgo und Bad Salzuflen." } },
      { "@type": "Question", "name": "Wie lange dauert eine Fassadensanierung?", "acceptedAnswer": { "@type": "Answer", "text": "Eine typische Fassadensanierung eines Einfamilienhauses dauert 1–3 Wochen. Komplette WDVS-Systeme bei größeren Objekten 3–4 Wochen." } },
      { "@type": "Question", "name": "Was unterscheidet Malerfachbetrieb Stein von anderen Malern in Herford?", "acceptedAnswer": { "@type": "Answer", "text": "Meistergeführter Fachbetrieb seit 2014 mit Schwerpunkt energetische Sanierung und hochwertige Oberflächen: WDVS, Calciumsilikat-Innendämmung, Mikrozement und exklusive Spachteltechnik." } }
    ]
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Startseite", "item": "https://malerfachbetrieb-stein.de/" }
    ]
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [localBusinessSchema, faqSchema, breadcrumbSchema]
  };

  return (
    <div className="min-h-screen">
    <SEO 
        title="Malerfachbetrieb in Herford: Fassade, Dämmung & Bäder"
        description="Malermeister in Herford für WDVS, energetische Sanierung, Schimmelschutz & fugenlose Bäder. 24h Rückruf, kostenloser Fassaden-Check."
        keywords="Maler Herford, Malerfachbetrieb Herford, Fassadensanierung Herford, WDVS Herford, Innendämmung Herford, Schimmelsanierung Herford, energetische Sanierung Herford, Badrenovierung Herford, Mikrozement Herford, Designboden Herford, Spachteltechnik Herford"
        canonical="https://malerfachbetrieb-stein.de/"
        structuredData={structuredData}
      />
      <Navigation />
      <WhatsAppButton />
      <main>
        {/* 1. Hero – Above the Fold */}
        <Hero />
        {/* 2. Trust-Bar – Beweise */}
        <TrustBar />
        {/* 3. Steckenpferd – WDVS & Sanierung */}
        <WDVSFocus />
        {/* 4. Leistungs-Hub – Weitere Bereiche */}
        <ServiceClusters />
        {/* 5. Technik-Expertise – KI-Vorteil */}
        <EnergieKlima />
        {/* 6. Über uns – E-E-A-T */}
        <AboutSEO />
        {/* 7. Lokale Autorität – Herford-Bonus */}
        <LocalRelevance />
        {/* 8. Referenzen */}
        <References />
        {/* 9. Google Bewertungen */}
        <GoogleReviews />
        {/* 10. FAQ – SGE/KI-Optimierung */}
        <FAQShort />
        {/* 11. Kontakt */}
        <Contact />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
};

export default Index;
